import { render, staticRenderFns } from "./ImpactArea.vue?vue&type=template&id=7313b6a1&scoped=true&"
import script from "./ImpactArea.vue?vue&type=script&lang=js&"
export * from "./ImpactArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313b6a1",
  null
  
)

export default component.exports